import {
  faChevronLeft,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { reduce } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import getCorePopUpStore from "../../../../../../stores/core/core-popup-store";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import { TAlbum } from "../../../../../../Types";
import Et3Image from "../../../../../../core/et3-Image";
import Et3CustomizedButton from "../../../../../../core/et3-button/Et3CustomizedButton";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import { SURFACE_BORDER } from "../../../../../../core/et3-theme/surface-constants";
import { DETAILS_IMAGE_WIDTH } from "../details-box-constants";
import {
  IMAGE_ALBUM_BUTTON_SIZE,
  IMAGE_ALBUM_ICON_SIZE,
  IMAGE_PAGER_BUTTON_WIDTH,
  IMAGE_PAGER_FONT_SIZE,
  IMAGE_PAGER_HEIGHT,
  IMAGE_PAGER_ICON_SIZE,
  IMAGE_PAGER_RADIUS_CSS,
  IMAGE_PAGER_WIDTH
} from "./image-column-constants";

type UserImageArrowsProps = {
  currentIndex: number;
  imageArray: TAlbum[];
  onNextPress: () => void;
  onPreviousPress: () => void;
  moreThanOnePicture: boolean;
};

const UserImageArrows = withLiteObserverAndTheme<UserImageArrowsProps>(
  (props) => {
    const {
      theme,
      currentIndex,
      imageArray,
      onNextPress,
      onPreviousPress,
      moreThanOnePicture
    } = props;
    const { colors, unitX, unitY } = theme;
    const userID = getUserAdvancedStore().currentUserId.get();
    const pictures = reduce(
      () => getUserAdvancedStore().userData.get(userID).pictures,
      []
    );

    return moreThanOnePicture ? (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={DETAILS_IMAGE_WIDTH}
        height={IMAGE_PAGER_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="space-between"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={IMAGE_PAGER_WIDTH}
          height={IMAGE_PAGER_HEIGHT}
          fDirection="row"
          alignItems="center"
          justifyContent="space-between"
          color={colors.all.white}
          style={{
            boxSizing: "border-box",
            border: SURFACE_BORDER,
            borderRadius: IMAGE_PAGER_RADIUS_CSS,
            overflow: "hidden"
          }}
          onClick={() => {}}
        >
          <Et3CustomizedButton
            alignItems="center"
            fDirection="row"
            color={colors.all.transparent}
            justifyContent="center"
            withShadow={false}
            width={IMAGE_PAGER_BUTTON_WIDTH}
            height={IMAGE_PAGER_HEIGHT}
            isEnabled={true}
            style={{}}
            onClick={() => {
              onPreviousPress();
            }}
          >
            <FontAwesomeIcon
              icon={faChevronLeft}
              color={colors.all.bondiBlue}
              style={{
                width: IMAGE_PAGER_ICON_SIZE * unitX,
                height: IMAGE_PAGER_ICON_SIZE * unitY
              }}
            />
          </Et3CustomizedButton>
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={IMAGE_PAGER_FONT_SIZE}
            text={`${currentIndex + 1} / ${imageArray.length}`}
            isSpan={true}
            color={colors.all.davysGrey}
            style={{ margin: 0 }}
          />
          <Et3CustomizedButton
            alignItems="center"
            fDirection="row"
            color={colors.all.transparent}
            justifyContent="center"
            withShadow={false}
            width={IMAGE_PAGER_BUTTON_WIDTH}
            height={IMAGE_PAGER_HEIGHT}
            isEnabled={true}
            style={{}}
            onClick={() => {
              onNextPress();
            }}
          >
            <FontAwesomeIcon
              icon={faChevronRight}
              color={colors.all.bondiBlue}
              style={{
                width: IMAGE_PAGER_ICON_SIZE * unitX,
                height: IMAGE_PAGER_ICON_SIZE * unitY
              }}
            />
          </Et3CustomizedButton>
        </ET3Div>
        {pictures.length > 0 ? (
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={IMAGE_ALBUM_BUTTON_SIZE}
            height={IMAGE_ALBUM_BUTTON_SIZE}
            fDirection="column"
            alignItems="center"
            justifyContent="center"
            color={colors.all.white}
            style={{
              boxSizing: "border-box",
              border: SURFACE_BORDER,
              borderRadius: IMAGE_PAGER_RADIUS_CSS,
              height: IMAGE_ALBUM_BUTTON_SIZE * unitX,
              minHeight: IMAGE_ALBUM_BUTTON_SIZE * unitX,
              cursor: "pointer"
            }}
            onClick={() => getCorePopUpStore().openPicAlbumPopUp()}
          >
            <Et3Image
              type="LOCAL"
              alt={i18n.get("USER_ALBUM_PICTURES")}
              imageName={"mask"}
              size={IMAGE_ALBUM_ICON_SIZE}
              onClick={() => {}}
              style={{ cursor: "pointer" }}
            />
          </ET3Div>
        ) : null}
      </ET3Div>
    ) : null;
  }
);
export default UserImageArrows;
